import { FC, useContext, useEffect, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import './typifyerrormodal.css'
import { MdDriveFileRenameOutline } from 'react-icons/md'
import { InputText } from "primereact/inputtext";
import { Editor } from 'primereact/editor';
import { InputTextarea } from "primereact/inputtextarea";
import { Steps } from 'primereact/steps';
import { catchResponse } from "../../../utils/helperFunctions";
import { UserContext } from "../../../Redux/UserContext";
import { editError, saveError } from "../../../services/errors-service";
import { error, success } from "../../../utils/notifications";
import { FiCommand } from "react-icons/fi";

export const TypifyErrorModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, flagErrors, setFlagErrors, selectedError, setSelectedError,editMode, setEditMode } = props

    const [state] = useContext(UserContext)

    const [name, setName] = useState<string>("")
    
    const [text, setText] = useState<string>("");

    const [value, setValue] = useState("");

    const [loadingTipificar, setLoadingTipificar] = useState<boolean>(false)


    useEffect(() => {
        if(editMode && selectedError) {
            setName(selectedError.nombreerror)
            setText(selectedError.pasos)
            setValue(selectedError.descripcion)
        } 
    },[selectedError])

    const headerContent = (
        <div className="asign-user-header">
            {editMode && state?.rol_id === 1?
                <span>Edición de error</span> 
            :
            editMode && state?.rol_id !== 1?
                <span>Visualización de error</span>
                :
                <span>Tipificación de error</span>
            }
            
            
        </div>
    )

    const [activeIndex, setActiveIndex] = useState<number>(0);
 
    const items = [
        {
            label: 'Nombre del error',
            
        },
        {
            label: 'Descripción del error',
            
        },
        {
            label: 'Pasos a seguir',
            
        }
    ];

    const handleChangeName = (e:any) => {
        setName(e.target.value)

        
    }

    const handleChangeEditor = (e:any) => {
        if(e.textValue == '\n' && e.htmlValue === null) {
            setText("")
        } else if(e.textValue == '\n' && e.htmlValue !== null) {
            setText(e.htmlValue)
        } else {
            setText(e.htmlValue)
        }
        
    }

    const handleRegisterError = async () => {
        try {
            setLoadingTipificar(true)
            let body = {
                nombreerror: name,
                descripcion: value,
                pasos: text,
                id_user: state?.localAccountId,
                registrado_por: state?.name
            }

            const res = await saveError(body)
            if(res.status === 200) {
                const {code,message} = res.data
                if(code === 200) {
                    setLoadingTipificar(false)
                    handleCloseModal()
                    setFlagErrors(!flagErrors)
                    success(message)
                } else {
                    setLoadingTipificar(false)
                    error(message)
                }
            } else {
                setLoadingTipificar(false)
                error("No se ha podido registrar el error.")
            }
        } catch(err:any) {
            setLoadingTipificar(false)
            catchResponse(err)
        }
    }

    const handleEditError = async () => {
        try {
            setLoadingTipificar(true)
            let body = {
                nombreerror: name,
                descripcion: value,
                pasos: text,
                id_user: state?.localAccountId,
                registrado_por: state?.name
            }

            const res = await editError(selectedError.idtipoerror,body)
            if(res.status === 200) {
                const {code,message} = res.data
                if(code === 200) {
                    setLoadingTipificar(false)
                    handleCloseModal()
                    setFlagErrors(!flagErrors)
                    success(message)
                } else {
                    setLoadingTipificar(false)
                    error(message)
                }
            } else {
                setLoadingTipificar(false)
                error("No se ha podido registrar el error.")
            }
        } catch(err:any) {
            setLoadingTipificar(false)
            catchResponse(err)
        }
    }

    const renderSteps = () => {
        switch(activeIndex) {
            case 0:
                return (
                    <div style={{height:'75%',display:'flex',justifyContent:'flex-start',alignItems:'center',flexDirection:'column',position:'relative'}}>
                       <span style={{fontFamily:'var(--roboto-light)', fontSize:'1.2rem'}}>Proporciona un nombre descriptivo para identificar al error.</span>

                        <div className="card flex justify-content-center" style={{marginTop:'2rem',marginBottom:'2rem'}}>
                            <div className="permisos__header-input">
                                <InputText id={"error-name"} style={{width:300,fontSize:'1rem'}}   value={name} onChange={handleChangeName}  />

                                    <span className="p-inputgroup-addon">
                                        <MdDriveFileRenameOutline style={{fontSize:20}} />
                                    </span>
                                </div>
                        
                        </div>
                        
                        <Button disabled={name === ""} style={{minWidth:200,position:'absolute',fontFamily:'var(--roboto-light)', fontSize:'1rem',bottom:'5%',right:'10%',color:'red'}} label="Siguiente" icon="pi pi-arrow-right"  onClick={() => setActiveIndex(1)}  outlined />

           
                    </div>
                )
            case 1:
                return (
                    <div style={{height:'75%',display:'flex',justifyContent:'flex-start',alignItems:'center',flexDirection:'column',position:'relative'}}>
                       <span style={{fontFamily:'var(--roboto-light)', fontSize:'1.2rem'}}>Proporciona un texto extenso que describa lo que ha ocurrido.</span>

                       <div className="card flex justify-content-center" style={{marginTop:'2rem',marginBottom:'2rem'}}>
                        <span className="p-float-label">
                            <InputTextarea  style={{resize:'none'}}  id="description" value={value} onChange={(e:any) => setValue(e.target.value)} rows={10} cols={100} />
                        </span>
                        </div>
                        <Button style={{minWidth:200,position:'absolute',fontFamily:'var(--roboto-light)', fontSize:'1rem',bottom:'5%',left:'10%',color:'gray'}} label="Anterior" icon="pi pi-arrow-left"  onClick={() => setActiveIndex(0)}  outlined />

                        <Button disabled={value === ""} style={{minWidth:200,position:'absolute',fontFamily:'var(--roboto-light)', fontSize:'1rem',bottom:'5%',right:'10%',color:'red'}} label="Siguiente" icon="pi pi-arrow-right"  onClick={() => setActiveIndex(2)}  outlined />

           
                    </div>
                )

            case 2:
                    return (
                        <div style={{height:'75%',display:'flex',justifyContent:'flex-start',alignItems:'center',flexDirection:'column',position:'relative'}}>
                           <div className="card card-editor-text" style={{height:'80%',width:'90%'}}>
                                <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-description"}>Determina los pasos a seguir para solventar este error</label>
                                <Editor style={{height:'80%'}} value={text} onTextChange={handleChangeEditor} />
                            </div>


                        <Button style={{minWidth:200,position:'absolute',fontFamily:'var(--roboto-light)', fontSize:'1rem',bottom:'5%',left:'10%',color:'gray'}} label="Anterior" icon="pi pi-arrow-left"  onClick={() => setActiveIndex(1)}  outlined />
                        
                        {
                            state?.rol_id === 1 && !(selectedError?.registrado_por === "" || selectedError?.registrado_por === null)?
                            <Button disabled={text === null || text === "" || (state?.rol_id !== undefined? [2,3,4,6].includes(state.rol_id) : true)} style={{minWidth:200,position:'absolute',fontFamily:'var(--roboto-light)', fontSize:'1rem',bottom:'5%',right:'10%',color:'red'}} label={editMode? "Actualizar" : "Registrar"} icon={loadingTipificar? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'red'}} /> :"pi pi-save" }  onClick={editMode? handleEditError : handleRegisterError}  outlined />
                            :
                            false
                        }
    
               
                        </div>
                    )
        }
    }

    const handleCloseModal = () => {
        setVisible(false)
        setText("")
        setName("")
        setValue("")
        setSelectedError(undefined)
        setEditMode(false)
        setActiveIndex(0)
    }

    const handleOnSelect = (e:any) => {
        switch(e.index) {
            case 0:
                setActiveIndex(e.index)
                break;
            case 1:
                name && setActiveIndex(e.index) 
                break;
            case 2:
                name && value && setActiveIndex(e.index)
                break;
        }
        
    }


    return (
        <div className="card flex justify-content-center">
            <Dialog className="dialog-error" header={headerContent} visible={visible} style={{ width: '70vw', height:'95vh' }} onHide={handleCloseModal} >
                <Steps model={items} onSelect={(e) => handleOnSelect(e)} activeIndex={activeIndex} style={{marginTop:'0.5rem',marginBottom:'0.5rem',fontFamily:'var(--roboto-light)',fontSize:'0.85rem',height:'15%'}}  readOnly={false} />
                {renderSteps()}  
            </Dialog>
        </div>
    )
}